module.exports = __webpack_public_path__ + "static/media/growth-icon.eeb8b092.svg";